import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getAllCompanies } from '../../api/companies';
import './GlobalCompanySwitcher.scss';

const GlobalCompanySwitcher = () => {
  const {
    viewingCompanyId,
    setViewingCompany,
    isSuperAdmin,
  } = useAuth();

  const [companies, setCompanies] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      const saved = localStorage.getItem('global-dept-switcher-collapsed');
      return saved === 'true';
    } catch (error) {
      return false;
    }
  });

  // 載入公司列表（Super Admin）
  useEffect(() => {
    if (isSuperAdmin()) {
      loadCompanies();
    }
  }, [isSuperAdmin]);

  const loadCompanies = async () => {
    const { data, error } = await getAllCompanies();
    if (!error && data) {
      setCompanies(data);
    }
  };

  const handleCompanyChange = (e) => {
    const newCompanyId = e.target.value;
    setViewingCompany(newCompanyId);
  };

  const handleToggleCollapse = () => {
    const newCollapsed = !isCollapsed;
    setIsCollapsed(newCollapsed);
    localStorage.setItem('global-dept-switcher-collapsed', newCollapsed);
  };

  // 只有 Super Admin 才顯示（只有他需要切換公司）
  if (!isSuperAdmin()) {
    return null;
  }

  // 收合狀態
  if (isCollapsed) {
    return (
      <div className="global-company-switcher collapsed" onClick={handleToggleCollapse}>
        <div className="switcher-icon">
          <span>🏭</span>
        </div>
      </div>
    );
  }

  // 展開狀態
  return (
    <div className="global-company-switcher expanded">
      <button className="collapse-btn" onClick={handleToggleCollapse} title="收合">
        ✕
      </button>

      <div className="switcher-content">
        <div className="switcher-row">
          <label className="switcher-label">
            <span className="icon">🏭</span>
            <span className="label-text">公司</span>
          </label>
          <select
            className="switcher-select"
            value={viewingCompanyId || ''}
            onChange={handleCompanyChange}
          >
            {companies.length === 0 && (
              <option value="">尚無公司</option>
            )}
            {companies.map(company => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default GlobalCompanySwitcher;
